<template>
  <!-- IEはsvgの中の要素にcss transformが効かないのでsvgを分割する -->
  <span class="icon">
    <icon-svg-base
      :view-width="20"
      :view-height="20"
      class="icon__base"
    >
      <circle
        cx="10"
        cy="10"
        r="7"
      />
    </icon-svg-base>
    <icon-svg-base
      :view-width="20"
      :view-height="20"
      class="icon__rotate"
    >
      <path
        d="M10,3a7,7,0,0,1,7,7"
      />
    </icon-svg-base>
  </span>
</template>

<script>
import IconSvgBase from '@/mikan/_shared/components/atoms/icons/IconSvgBase.vue';

export default {
  components: {
    IconSvgBase,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/mikan/_shared/base/constants';
@import '~@/mikan/_shared/base/mixins';

.icon {
  position: relative;
  display: inline-flex;
  width: 1em;
  height: 1em;
  align-items: center;
  justify-content: center;

  &__base {
    fill: transparent;
    stroke: currentColor;
    stroke-opacity: 0.4;
    stroke-width: 3;
  }

  &__rotate {
    @include animate-rotate;

    position: absolute;
    top: 0;
    left: 0;
    fill: transparent;
    stroke: currentColor;
    stroke-width: 3;
    transform-origin: center;
  }
}
</style>
